import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';

import { PermissionsService } from '../../../permissions/permissions.service';


@Component({
  moduleId: module.id,
  selector: 'btn-renderer',
  templateUrl: 'btn-renderer.component.html',
  styleUrls: ['btn-renderer.component.scss'],
})
export class BtnRendererComponent {
  @Input() row: any;
  @Input() column: any;
  @Input() text: string;

  @Output() btnClick = new EventEmitter<any>();

  constructor(
    private permissionsService: PermissionsService,
  ) {}

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get columnConfig(): any {
    const columnConfig: any = _.cloneDeep(_.get(this.column, 'config'));
    if (columnConfig) {
      // @ts-ignore
        _.mapKeys(columnConfig, (value: any, key: string) => {
        if (typeof value === 'function') {
          columnConfig[key] = columnConfig[key](this.row);
        }
      });
    }
    return columnConfig ? columnConfig : {};
  }

  get columnType(): string {
    return this.columnConfig.type;
  }

  get hasPermissionForLink(): boolean {
    if (this.column.permissions) {
      return this.hasPermission(this.column.permissions);
    }
    return true;
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  public hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onBtnClick() {
    this.btnClick.emit({column: this.column, row: this.row});
  }
}
